module.exports = __webpack_public_path__ + "img/media (20).169f607f.png";